import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Logo } from './Logo';
import { Button } from '@/components/ui';
import { VerdictFooter } from '@/components/verdict';

interface LegalLayoutProps {
  children: React.ReactNode;
  title: string;
  lastUpdated: string;
}

export function LegalLayout({ children, title, lastUpdated }: LegalLayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b border-border">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <Logo size="md" linkTo="/" />
          <div className="flex items-center gap-4">
            <Link to="/">
              <Button variant="ghost" leftIcon={<ArrowLeft className="w-4 h-4" />}>
                Back to Home
              </Button>
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 py-12">
        <div className="mb-8">
          <h1 className="text-3xl md:text-4xl font-bold mb-2">{title}</h1>
          <p className="text-text-secondary text-sm">Last updated: {lastUpdated}</p>
        </div>
        
        <div className="prose prose-invert prose-lg max-w-none">
          {children}
        </div>
      </main>

      <VerdictFooter className="mt-12" />
    </div>
  );
}

